import { UniqueIdentifier } from '@dnd-kit/core';
import React from 'react';

import { Stack, Text } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';
import { GroupBlock } from '@eluve/llm-outputs';

import { BlockPicker } from '../BlockPicker';
import { AsBuilderBlock } from '../utilities';

export interface GroupBlockControlProps {
  parentId: UniqueIdentifier | null;
  group: AsBuilderBlock<GroupBlock>;
}

export const GroupBlockControl: React.FC<GroupBlockControlProps> = ({
  group,
}) => {
  const { t } = useTranslation();
  return (
    <Stack gap={3} direction="horizontal">
      <Text inline className="text-nowrap">
        {t('smartBlocks.blockPicker.add')}
      </Text>
      <BlockPicker parentId={group.id} />
    </Stack>
  );
};
